document.querySelectorAll('[data-urgency-timer]').forEach((el) => {
  const minutes = Number(el.dataset.minutes) || 10;
  let remaining = minutes * 60;

  const render = () => {
    const m = Math.floor(remaining / 60);
    const s = remaining % 60;
    el.textContent = `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  };

  render();
  const interval = setInterval(() => {
    remaining -= 1;
    render();
    if (remaining <= 0) clearInterval(interval);
  }, 1000);
});

// "People viewing" count climbs from a small number up to the real target
// in +50-70 steps every 2s, then keeps drifting within a band around the
// target so it feels "live" for as long as the visitor stays on the page —
// ignored when the visitor prefers reduced motion (jumps straight to the
// target, no ongoing ticking).
document.querySelectorAll('[data-urgency-viewers]').forEach((el) => {
  const target = Number(el.dataset.target) || 0;
  if (target <= 0) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    el.textContent = target;
    return;
  }

  const driftFloor = Math.round(target * 0.85);
  const driftCeiling = Math.round(target * 1.15);
  let value = Math.min(target, Math.floor(Math.random() * 31) + 30);
  el.textContent = value;

  setInterval(() => {
    if (value < target) {
      value = Math.min(target, value + Math.floor(Math.random() * 21) + 50);
    } else {
      const drift = Math.floor(Math.random() * 31) - 15;
      value = Math.min(driftCeiling, Math.max(driftFloor, value + drift));
    }
    el.textContent = value;
  }, 2000);
});
